import backgroundPic from '../../../Pics/Landscapes/jpeg/moonMountain.jpg'

export const titleCardData = {
        titleText: 'Metaphysical Services for Personal Wellbeing',
        subText: 'THE COLLECTIVE THAT SUPPORTS YOUR ABUNDANT LIFE',
        backgroundimage: backgroundPic
}
